// extracted by mini-css-extract-plugin
export default {"switch-account":"h6VLJ","modal":"ygL4s","portal":"DpMUV","title":"bhhkk","description":"qBQus"};